<template>
  <div class="p-1">
    <template v-if="!['Seller','Partner'].includes(currentUser.type) && !activeTab">
      <div class="flex items-center justify-center" style="min-height: 60vh;">
        <div class="flex gap-6 flex-wrap justify-center">
          <div @click="switchTab('all')" class="req-type-box req-type-all">
            <div class="req-type-icon-wrap req-type-icon-all">
              <i class="material-icons">list</i>
            </div>
            <span class="req-type-label">Tout</span>
            <span class="req-type-desc">Voir toutes les demandes</span>
          </div>
          <div @click="switchTab('affiliate')" class="req-type-box req-type-affiliate">
            <div class="req-type-icon-wrap req-type-icon-affiliate">
              <i class="material-icons">group</i>
            </div>
            <span class="req-type-label">Affiliate</span>
            <span class="req-type-desc">Demandes d'affiliation</span>
          </div>
          <div @click="switchTab('cpa')" class="req-type-box req-type-cpa">
            <div class="req-type-icon-wrap req-type-icon-cpa">
              <i class="material-icons">trending_up</i>
            </div>
            <span class="req-type-label">CPA</span>
            <span class="req-type-desc">Demandes CPA</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="!['Seller','Partner'].includes(currentUser.type)" class="flex items-center mb-3">
        <button @click="activeTab = null" class="flex items-center text-sm text-gray-500 hover:text-blue-600 focus:outline-none mr-3">
          <i class="material-icons text-base mr-1">arrow_back</i> Retour
        </button>
        <span class="text-sm font-semibold text-gray-700">{{ activeTab === 'all' ? 'Tout' : activeTab === 'affiliate' ? 'Affiliate' : 'CPA' }}</span>
      </div>
      <div-table
        :config="configList"
        :data="charges"
        :idWharhouse="idWharhouse"
        :currentUser="currentUser"
        :limit="limit"
        @reset="reset"
        @refresh="refresh"
        @filtrer="filtrer"
        @search="search"
        :loading="loading"
        :paginate="paginate"
        @paginatation="paginatation"
        @Changelimit="Changelimit"
      ></div-table>
    </template>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
        currentUser: { type: Object},
        idWharhouse: { type: Object}
  },
  data() {
    return {
      activeTab: null,
      configList: config.list,
      loading: false,
      formData: {},
      charges: [],
      sellers: [],
      tabId:[],
      limit: 10,
      filters:{},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
    },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {

      },
      'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          await this.reset();
         // if (this.currentUser.type != "Seller") {  await this.getSellers();this.setDataSelect("seller", this.sellers, null);}
      }
},
  async mounted() {

    if (['Seller','Partner'].includes(this.currentUser.type)) {
        let pos = this.configList.columns.map(function (e) {return e.name;}).indexOf('Seller');
        if(pos!=-1)  this.configList.columns.splice(pos, 1);
        this.filters.status="approved";
        this.activeTab = 'all';
    }
    if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
    else this.$f.objectToQueryString({limit:this.limit,...(['Seller','Partner'].includes(this.currentUser.type)?{status:"approved"}:{})})

    if(this.filters['productObject.type'] && ['affiliate','cpa'].includes(this.filters['productObject.type'])) {
        this.activeTab = this.filters['productObject.type'];
    } else if(this.filters['productObject.type'] === undefined && !['Seller','Partner'].includes(this.currentUser.type) && !this.$f.QueryStringToobject()) {
        this.activeTab = null;
    }

    if(this.activeTab) {
        if(this.filters.name) await this.search(this.filters.name);
        else await this.getAvoirs(this.filters);
    }
    if (!['Seller','Partner'].includes(this.currentUser.type)) await this.getSellers();
    this.setDataSelect("seller", this.sellers, null);
    this.setDataSelect("status", ['pending','approved','rejected'], null);
    this.setDataSelect("type", ['affiliate','cpa'], null);
    this.setDataSelect("category", this.$f.defaultCategories(), null);
    this.setDataSelect("warehouse",this.currentUser.countries, null);
  },
  methods: {
    async switchTab(tab) {
      this.activeTab = tab;
      if(this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      if(tab === 'all') { delete this.filters['productObject.type']; }
      else { this.filters['productObject.type'] = tab; }
      this.filters.page = 1;
      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    },
     setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
         type: "Seller",
         countries:this.idWharhouse.country,
         limit:10,
      };
       if (!['Seller','Partner'].includes(this.currentUser.type)) {
          const res = await this.$server.search("users", filter);
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
       }
    },
    async Changelimit(val){
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       this.filters['limit']=val;
       this.filters['page']=1;
       this.paginate.currentpage=1;
       this.$f.objectToQueryString(this.filters)
       if(this.filters.name) await this.search(this.filters.name);
       else this.getAvoirs(this.filters);
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       console.log('filter search________',data)
       this.paginate.currentpage=1;
       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.seller)  {this.filters['seller._id']=data.seller._id;}else delete this.filters['seller._id'];
       if(data.status)  {this.filters.status=data.status;}else delete this.filters.status;
       if(this.activeTab !== 'all') { this.filters['productObject.type'] = this.activeTab; }
       else if(data.type)  {this.filters['productObject.type']=data.type;}else delete this.filters['productObject.type'];
       if(data.Range_date && data.Range_date[0]){this.filters.Range_date=data.Range_date.map( el => this.$moment(el).format('yyyy-MM-DD'));}else delete this.filters.Range_date;
       if(data.warehouse)  {this.filters['productObject.countries']=data.warehouse.code;}else delete this.filters['productObject.countries'];
       if(data.category)  {this.filters['productObject.category']=data.category;}else delete this.filters['productObject.category'];
       this.$f.objectToQueryString(this.filters)
      await this.getAvoirs(this.filters);
    },
    /**********************************User and Status******************************************************/

   
    async reset() {
        let lmitt=this.limit;
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        if(this.filters['limit']) lmitt=this.filters['limit'];
        this.filters['page']=1;
        const resetFilters = {limit:lmitt};
        if(this.activeTab !== 'all') resetFilters['productObject.type'] = this.activeTab;
        this.$f.objectToQueryString(resetFilters)
        this.filters = resetFilters;
        await this.getAvoirs(resetFilters);
    },
    async refresh() {
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        this.$f.objectToQueryString(this.filters)
        if(this.filters.name) await this.search(this.filters.name);
        else await this.getAvoirs(this.filters);
       if(this.filters['page'] && this.filters['page']>1 && this.charges.length==0){
          this.filters['page']= --this.filters['page'];
           this.$f.objectToQueryString(this.filters)
          await this.getAvoirs(this.filters);
       }
    },
    async getAvoirs(filters) {
      this.loading = true;
      const res = await this.$server.search("affiliates", filters);
      this.loading = false;
      if (res && res.content.results) {
        this.charges = res.content.results;
        this.charges.forEach(function (offre) {
          offre.oldStatus= offre.status;
        }.bind(this));

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
    },
    async search(data) {
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];
       const search = {
        name:data.trim(),
        limit:parseInt(limitt),
      }
      if(this.activeTab !== 'all') search['productObject.type'] = this.activeTab;

     this.$f.objectToQueryString(search)
     const  res = await this.$server.find("affiliates", search);
       if (res.content.results) {
        this.charges = res.content.results; 
        this.charges.forEach(function (offre) {
          offre.oldStatus= offre.status;
        }.bind(this));
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
        
    },
    async remove(id) {
      this.$confirm("You want to delete this affiliate?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("affiliates", { id: id });
          await this.refresh();
          alert("affiliate Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.getAvoirs(this.filters);
    },
  },
};
</script>

<style scoped>
.req-type-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 220px;
  padding: 32px 24px 28px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.req-type-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.req-type-all:hover { box-shadow: 0 8px 24px rgba(59,130,246,0.18); }
.req-type-affiliate:hover { box-shadow: 0 8px 24px rgba(245,158,11,0.18); }
.req-type-cpa:hover { box-shadow: 0 8px 24px rgba(16,185,129,0.18); }
.req-type-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.req-type-icon-wrap i {
  font-size: 28px;
  color: #fff;
}
.req-type-icon-all {
  background: linear-gradient(135deg, #3b82f6, #6366f1);
}
.req-type-icon-affiliate {
  background: linear-gradient(135deg, #f59e0b, #f97316);
}
.req-type-icon-cpa {
  background: linear-gradient(135deg, #10b981, #059669);
}
.req-type-label {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 6px;
  letter-spacing: 0.01em;
}
.req-type-desc {
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
  line-height: 1.4;
}
</style>
